@if (message.isShownInChat !== false && !message.isHidden) {
<div class="flex flex-col w-full mb-6"
     [ngClass]="message.isUser ? 'items-end' : 'items-start'">

  @if (!message.isUser && message.type !== 'action-response') {
  <div class="flex items-center gap-2 mb-1 ml-1">
    <i class="fas fa-sparkles text-primary text-xs"></i>
    <span class="text-xs font-bold text-secondary-text tracking-wide">Rapider AI</span>
  </div>
  }

  @switch (message.type) {

  @case ('action-response') {
  <div class="flex flex-col w-full items-center my-3 gap-2">

    @if (message.actionResponseData) {
    <button (click)="showActionResponseInCanvas()"
            class="flex items-center gap-2 px-4 py-1.5 rounded-full bg-alt-background border border-secondary-border shadow-sm text-xs font-medium text-secondary-text hover:text-primary hover:border-primary transition-colors focus:outline-none max-w-[90%]">
      <i class="fas"
         [ngClass]="(message.isError || message.actionResponseData.actionResponseStatus === 'error') ? 'fa-exclamation-circle text-danger' : 'fa-check-circle text-success'"></i>
      <span class="truncate">
        @if (message.actionResponseData.actionType === 'rapider-workflow' && message.actionResponseData.actionResponseStatus === 'success') {
        <ng-container i18n="@@workflowStartedSuccessfully">Workflow started successfully</ng-container>
        } @else {
        {{ message.text }}
        }
      </span>
    </button>
    }

    @if (message.workflowPlanUpdate) {
    <div
         class="flex items-center gap-2 px-4 py-1.5 rounded-full bg-alt-background border border-secondary-border shadow-sm text-xs font-medium text-secondary-text max-w-[90%]">
      <i class="fas"
         [ngClass]="message.workflowPlanUpdate.status === 'failed' ? 'fa-times-circle text-danger' : 'fa-check-circle text-success'"></i>
      <span class="truncate">{{ message.text }}</span>
    </div>
    }

    @if (message.transformationResult) {
    <div
         class="flex flex-col items-center gap-2 w-full max-w-[85%] sm:max-w-[75%] rounded-xl shadow-sm border border-secondary-border bg-component-inner overflow-hidden mb-1">
      <div class="px-4 py-2 border-b border-secondary-border bg-alt-background flex items-center gap-2 w-full">
        <i class="fas fa-check-circle text-success text-xs"></i>
        <span class="text-[11px] font-bold uppercase tracking-wider text-primary-text"
              i18n="@@aiChat.transformationResultTitle">Transformation Result</span>
      </div>
      <div class="p-3 bg-alt-background overflow-x-auto max-h-[250px] custom-scrollbar w-full">
        <pre class="text-[11px] text-primary-text m-0">{{ message.transformationResult | json }}</pre>
      </div>
    </div>
    }

    @if (!message.actionResponseData && !message.workflowPlanUpdate && !message.transformationResult) {
    <div
         class="flex items-center gap-2 px-4 py-1.5 rounded-full bg-alt-background border border-secondary-border shadow-sm text-xs font-medium text-secondary-text max-w-[90%]">
      <i class="fas fa-check-circle text-success"></i>
      <span class="truncate">{{ message.text }}</span>
    </div>
    }

    @if (message.asyncProgress) {
    <div class="w-full">
      <rapider-chat-async-progress-card [progress]="message.asyncProgress"
                                        [attachments]="message.attachments"
                                        (fetchLogs)="onFetchLogs($event)">
      </rapider-chat-async-progress-card>
    </div>
    }
  </div>
  }

  @case ('workflow-step') {
  <div
       class="flex flex-col w-full rounded-xl shadow-sm border border-secondary-border bg-component-inner overflow-hidden mb-1 min-w-[280px] sm:min-w-[400px]">
    <div class="px-4 py-3 border-secondary-border bg-alt-background flex items-center justify-between cursor-pointer hover:bg-hover-default transition-colors"
         [ngClass]="!isWorkflowStepCollapsed() ? 'border-b' : ''"
         (click)="toggleWorkflowStepCollapse()">
      <div class="flex flex-wrap items-center gap-2">
        <nz-tag class="!m-0 text-[11px] font-black bg-primary/10 text-primary border-primary/20 shadow-sm px-2">
          {{ (message.workflowStepData?.stepIndex ?? 0) + 1 }}
        </nz-tag>
        <nz-tag
                class="!m-0 text-[10px] font-bold uppercase tracking-wider bg-section-background border-secondary-border text-primary-text shadow-sm flex items-center">
          <i class="fas {{ getTaskTheme(message.aiFunctionId || '').icon }} mr-1 text-primary"></i>
          {{ getTaskTheme(message.aiFunctionId || '').title }}
        </nz-tag>
        <nz-tag
                class="!m-0 text-[9px] font-bold uppercase tracking-wider !bg-component-inner !text-secondary-text !border-secondary-border !rounded-full border border-dashed flex items-center gap-1">
          <i class="fas fa-circle-notch fa-spin text-primary"></i>
          <span i18n="@@aiChat.statusInProgress">In Progress</span>
        </nz-tag>
      </div>
      <div class="flex items-center gap-3">
        <i class="fas text-secondary-text transition-transform"
           [ngClass]="isWorkflowStepCollapsed() ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
      </div>
    </div>
    @if (!isWorkflowStepCollapsed()) {
    <div class="p-4 bg-component-inner animate-fade-in">
      <p class="text-[13px] text-primary-text whitespace-pre-wrap leading-relaxed mb-0">{{
        message.workflowStepData?.description || message.text }}</p>
    </div>
    }
  </div>
  }

  @default {
  <div class="max-w-[100%] rounded-2xl px-4 pt-3 pb-1 flex flex-col gap-3 relative group"
       [ngClass]="message.isUser ? 'bg-alt-background border border-primary-border text-primary-text rounded-tr-sm min-w-[280px] sm:min-w-[400px]' : 'bg-component-inner text-primary-text rounded-tl-sm'">
    
    @if (message.asyncProgress) {
    <rapider-chat-async-progress-card [progress]="message.asyncProgress"
                                      [attachments]="message.attachments"
                                      (fetchLogs)="onFetchLogs($event)">
    </rapider-chat-async-progress-card>
    }

    @if (message.isVoiceMessage) {
    <div class="flex flex-col gap-1 w-full max-w-[800px] my-1">

      @if (message.voiceUrl || localVoiceUrl()) {
      <audio controls
             [autoplay]="autoPlayAudio()"
             [src]="localVoiceUrl() || message.voiceUrl"
             class="w-full h-[54px] outline-none rounded-full bg-alt-background border border-secondary-border shadow-sm"></audio>
      } @else {
      <button (click)="loadAudioBlob()"
              [disabled]="isLoadingAudio()"
              class="h-[54px] w-full bg-alt-background border border-secondary-border rounded-full flex items-center px-4 gap-3 hover:bg-hover-default transition-colors shadow-sm focus:outline-none cursor-pointer disabled:cursor-wait disabled:opacity-90">
        <div class="w-8 h-8 flex items-center justify-center shrink-0 text-primary-text">
          @if (isLoadingAudio()) {
          <i class="fas fa-circle-notch fa-spin text-lg text-primary"></i>
          } @else {
          <i class="fas fa-play ml-0.5"></i>
          }
        </div>

        <span class="text-sm text-primary-text shrink-0">{{ config.texts.voiceMessageLabel }}</span>

        <div class="flex-1 h-1.5 bg-secondary-border rounded-full overflow-hidden mx-2"></div>

        <div class="flex items-center gap-4 text-secondary-text shrink-0">
          <i class="fas fa-volume-up text-sm"></i>
          <i class="fas fa-ellipsis-v text-sm"></i>
        </div>
      </button>
      }

      @if (audioError()) {
      <span class="text-[10px] text-warning font-semibold leading-tight mt-1">{{ config.texts.voiceExpiredError
        }}</span>
      }
    </div>
    }

    @if (message.text || message.reasoningText || message.reasoningSteps || message.transcribedMessage) {
    <div class="leading-relaxed w-full min-w-0"
         [ngClass]="{'markdown-normalize text-base ai-message': !message.isUser, 'text-sm': message.isUser}">

      @if (message.isVoiceMessage && (message.transcribedMessage || message.text)) {
      <div class="mt-1 text-[13px] italic text-secondary-text whitespace-pre-wrap opacity-90 px-1">
        "{{ message.transcribedMessage || message.text }}"
      </div>
      } @else {

      @if (!message.isUser && (message.reasoningText || message.reasoningSteps)) {
      <div class="mb-3 border border-secondary-border rounded-lg bg-alt-background overflow-hidden shadow-sm">
        <button (click)="toggleReasoning()"
                class="w-full flex items-center justify-between px-3 py-2 text-xs font-semibold text-secondary-text hover:text-primary transition-colors focus:outline-none">
          <div class="flex items-center gap-2">
            @if (message.reasoningSteps && message.reasoningSteps.length > 0) {
              @if (isReasoningActive()) {
                <div class="flex space-x-0.5 items-center mr-1">
                  <div class="w-1.5 h-1.5 bg-primary rounded-full animate-bounce" style="animation-delay: 0s;"></div>
                  <div class="w-1.5 h-1.5 bg-primary rounded-full animate-bounce" style="animation-delay: 150ms;"></div>
                  <div class="w-1.5 h-1.5 bg-primary rounded-full animate-bounce" style="animation-delay: 300ms;"></div>
                </div>
              } @else {
                <i class="fas fa-check-circle text-success"></i>
              }
            } @else {
              <i class="fas fa-brain"></i>
            }
            <span>{{ getReasoningHeaderTitle() }}</span>
          </div>
          <i class="fas transition-transform duration-200"
             [ngClass]="isReasoningCollapsed() ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
        </button>
        @if (!isReasoningCollapsed()) {
        <div class="px-3 py-3 border-t border-secondary-border text-[13px] text-secondary-text bg-component-inner">

          @if (message.reasoningSteps && message.reasoningSteps.length > 0) {
          <div class="flex flex-col gap-3">
            @for (step of message.reasoningSteps; track $index) {
            <div class="flex items-start gap-2">
              <div class="mt-0.5 shrink-0 flex items-center justify-center min-w-[14px]">
                @if (step.status === 'completed') {
                  <i class="fas fa-check-circle text-success"></i>
                } @else if (step.status === 'failed') {
                  <i class="fas fa-times-circle text-danger"></i>
                } @else if (step.status === 'pending') {
                  <i class="fas fa-clock text-secondary-text"></i>
                } @else {
                  <div class="flex space-x-[2px] items-center h-3">
                    <div class="w-1 h-1 bg-primary rounded-full animate-bounce" style="animation-delay: 0s;"></div>
                    <div class="w-1 h-1 bg-primary rounded-full animate-bounce" style="animation-delay: 150ms;"></div>
                    <div class="w-1 h-1 bg-primary rounded-full animate-bounce" style="animation-delay: 300ms;"></div>
                  </div>
                }
              </div>
              <div class="flex flex-col">
                @if (step.title) { <span class="font-bold text-primary-text">{{ step.title }}</span> }
                <span class="text-secondary-text leading-relaxed">{{ step.content }}</span>
              </div>
            </div>
            }
          </div>
          }

          @if (message.reasoningText) {
          <rapider-markdown-preview [data]="message.reasoningText"
                                    [viewMode]="'compact'"
                                    [showHeader]="false"
                                    [showBorder]="false"
                                    [isTransparent]="true"
                                    class="opacity-80 block"></rapider-markdown-preview>
          }
        </div>
        }
      </div>
      }

      @if (message.text && (!message.asyncProgress || message.isUser)) {
      @if (message.isUser) {
      <span class="whitespace-pre-wrap">{{ message.text }}</span>
      } @else {
      <rapider-markdown-preview [data]="message.text"
                                [viewMode]="'compact'"
                                [showHeader]="false"
                                [showBorder]="false"
                                [isTransparent]="true"></rapider-markdown-preview>
      }
      }

      }
    </div>
    }

    @if (message.interactionConfig) {
    <rapider-chat-interaction-widget [config]="message.interactionConfig"
                                     [messageId]="message.id"
                                     [isResponded]="message.interactionState?.status === 'responded' || message.interactionState?.status === 'skipped'"
                                     [selectedValues]="message.interactionState?.selectedValues || []"
                                     (onSubmit)="submitInteraction($event)"
                                     (onSkip)="skipInteraction()">
    </rapider-chat-interaction-widget>
    }

    @if (message.memoryUpdates?.length) {
    <!-- Company Knowledge notes the runtime saved during this turn -->
    <div class="flex flex-wrap gap-1.5 w-full min-w-0 mt-2">
      @for (note of message.memoryUpdates; track note.pageKey) {
      <button type="button"
              (click)="openMemoryNote(note)"
              [title]="note.statement"
              class="inline-flex items-center gap-1.5 max-w-full rounded-full border border-primary/30 bg-primary/5 px-2.5 py-0.5 text-[11px] text-primary hover:bg-primary/10 transition-colors focus:outline-none">
        <i class="fa-solid fa-book-open shrink-0"></i>
        <span class="shrink-0">{{ memoryLabel(note) }}:</span>
        <span class="truncate font-medium">{{ note.title }}</span>
      </button>
      }
    </div>
    }

    @if (message.toolCalls) {
    <div class="flex flex-col gap-1 w-full min-w-0 mt-2">
      @for (toolCall of message.toolCalls; track toolCall.id || $index) {
      <rapider-chat-tool-call-card [toolCall]="toolCall"></rapider-chat-tool-call-card>
      }
    </div>
    }

    @if (message.actions && message.actions.length > 0) {
    <div class="mt-4 flex flex-col gap-4 pt-2 border-t border-primary-border w-full min-w-[300px]">
      @for (action of message.actions; track i; let i = $index) {

      @if (action.type === 'endpoint' || action.type === 'server_action' || action.execution === 'server') {
      <div class="flex flex-col gap-1.5 w-full">
        <rapider-chat-endpoint-action-card [action]="action"
                                           [message]="message"
                                           [index]="i + 1"
                                           [isDiscarded]="isActionDiscarded(i)"
                                           [isCollapsed]="collapsedActionIndices().has(i)"
                                           [hideExecuteButton]="false"
                                           [entityName]="message.entityData?.entityName"
                                           (toggleCollapse)="onToggleCollapse(i)"
                                           (execute)="executeAction($event)"
                                           (discard)="discardAction(i)"
                                           (undoDiscard)="undoDiscardAction(i)">
        </rapider-chat-endpoint-action-card>

        @if ((action.executionState?.status === 'success' || action.executionState?.status === 'error') &&
        isActionReExecutable(action)) {
        <div class="flex justify-end w-full px-1 animate-fade-in">
          <button nz-button
                  nzType="default"
                  nzSize="small"
                  (click)="executeAction(action)"
                  class="text-[11px] flex items-center gap-1.5 border border-primary/40 text-primary hover:bg-primary/10 hover:border-primary rounded px-3 py-0.5 shadow-sm transition-colors focus:outline-none">
            <i class="fas fa-redo"></i>
            <span i18n="@@aiChat.reExecuteEndpoint">Re-execute</span>
          </button>
        </div>
        }
      </div>
      }

      }

      @if (pendingActions().length > 1) {
      <div class="flex items-center justify-end mt-2 pt-2 gap-2">
        <button nz-button
                nzType="default"
                (click)="discardAllActiveActions()"
                [disabled]="pendingActions().length === 0"
                class="border border-danger/40 text-danger hover:bg-danger/10 hover:text-danger focus:outline-none flex items-center gap-2 rounded-[6px] font-medium py-1 px-3 text-[13px] shadow-none disabled:opacity-40 disabled:cursor-not-allowed">
          <i class="fas fa-trash-alt text-xs"></i>
          <span i18n="@@aiChat.discardAll">Discard All</span>
        </button>

        @if (areAllCollapsed()) {
        <button nz-button
                nzType="default"
                (click)="expandAllActions()"
                class="border-secondary-border text-secondary-text hover:text-primary-text hover:border-secondary-border focus:outline-none flex items-center gap-2 rounded-[6px] font-medium py-1 px-3 text-[13px] shadow-none">
          <i class="fas fa-expand-arrows-alt text-xs"></i>
          <span i18n="@@aiChat.expandAll">Expand All</span>
        </button>
        } @else {
        <button nz-button
                nzType="default"
                (click)="collapseAllActions()"
                class="border-secondary-border text-secondary-text hover:text-primary-text hover:border-secondary-border focus:outline-none flex items-center gap-2 rounded-[6px] font-medium py-1 px-3 text-[13px] shadow-none">
          <i class="fas fa-compress-arrows-alt text-xs"></i>
          <span i18n="@@aiChat.collapseAll">Collapse All</span>
        </button>
        }

        <button nz-button
                nz-popover
                [nzPopoverContent]="executeAllPopover"
                nzPopoverTitle="Actions to Execute"
                nzPopoverPlacement="left"
                [disabled]="pendingActions().length === 0"
                (click)="executeAllActiveActions()"
                class="bg-[#27272A] hover:bg-[#3F3F46] dark:bg-[#D4D4D8] dark:hover:bg-[#E4E4E7] text-[#FAFAFA] dark:text-[#18181B] border border-black/10 dark:border-white/10 shadow-xs focus:outline-none flex items-center gap-2 rounded-[6px] font-medium py-1 px-3.5 text-[13px] transition-colors disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer">
          <i class="fas fa-check-double text-xs"></i>
          @if (pendingActions().length === 1) {
          <span i18n="@@aiChat.executeAction">Execute Action</span>
          } @else {
          <span>{{ config.texts.executeAllActions }} ({{ pendingActions().length }})</span>
          }
        </button>
      </div>

      <ng-template #executeAllPopover>
        <div class="max-h-[250px] overflow-y-auto custom-scrollbar flex flex-col gap-1 pr-2 max-w-[400px]">
          @for (action of pendingActions(); track action.description; let i = $index) {
          <div class="text-sm text-primary-text py-2 border-b border-secondary-border last:border-0 leading-tight">
            <span class="font-bold mr-1 text-primary-text">{{ i + 1 }}.</span> {{ action.description }}
          </div>
          }
        </div>
      </ng-template>
      }

    </div>
    }
    @if (message.workflowPlan) {
    <div class="mt-2 w-full min-w-0 flex flex-col gap-2 pt-2 border-t border-primary-border">
      <rapider-chat-workflow-plan-card [plan]="message.workflowPlan"
                                       [isConfirmed]="isWorkflowConfirmed()"
                                       (execute)="executeWorkflowPlan($event)">
      </rapider-chat-workflow-plan-card>
    </div>
    }
    @if (message.entityData && !hasEndpointAction(message.actions)) {
    <div class="mt-4 w-full flex flex-col gap-2 pt-2 border-t border-primary-border">
      <rapider-chat-entity-data-card [entityName]="message.entityData.entityName"
                                     [data]="message.entityData.data"
                                     [gridConfig]="gridConfig()"
                                     [isGridLoading]="isGridLoading()"
                                     (showInCanvas)="onShowInCanvas()">
      </rapider-chat-entity-data-card>
    </div>
    }

    @if (visibleAttachments.length > 0 && !message.asyncProgress) {
    <div class="flex flex-wrap gap-2 mt-2 pt-2 border-t border-primary-border">
      @for (file of visibleAttachments; track file.id) {
      <div
           class="flex items-center gap-3 bg-component-inner border border-secondary-border rounded-lg px-3 py-2 hover:shadow-sm hover:border-primary transition-all group/attachment">

        <div (click)="handleAttachmentClick(file)"
             class="flex items-center gap-2 cursor-pointer"
             [title]="file.name">
          @if (file.isProcessing) {
          <i class="fas fa-circle-notch fa-spin text-primary"></i>
          } @else if (file.mimeType.startsWith('image/')) {
          <i class="fas fa-image text-primary"></i>
          } @else {
          <i class="fas fa-file-alt text-primary"></i>
          }
          <div class="flex flex-col min-w-0">
            <span class="text-xs font-medium text-primary-text truncate max-w-[120px]">{{ file.name }}</span>
            <span class="text-[10px] text-secondary-text">{{ file.mimeType.split('/')[1] | uppercase }} • {{
              formatSize(file.size) }}</span>
          </div>
        </div>

        <div
             class="flex items-center gap-1 opacity-0 group-hover/attachment:opacity-100 transition-opacity pl-2 border-l border-secondary-border">
          @if (isPreviewable(file)) {
          <button (click)="openInNewTab(file, $event)"
                  class="w-6 h-6 flex items-center justify-center rounded-full bg-alt-background text-secondary-text hover:text-primary hover:bg-primary/10 transition-colors focus:outline-none"
                  i18n-title="@@openInNewTabTitle"
                  title="Open in new tab">
            <i class="fas fa-external-link-alt text-[10px]"></i>
          </button>
          }
          <button (click)="triggerDownload(file, $event)"
                  class="w-6 h-6 flex items-center justify-center rounded-full bg-alt-background text-secondary-text hover:text-primary hover:bg-primary/10 transition-colors focus:outline-none"
                  i18n-title="@@downloadFileTitle"
                  title="Download">
            <i class="fas fa-download text-[10px]"></i>
          </button>
        </div>
      </div>
      }
    </div>
    }


    @if (message.jsonataTransformation) {
    <div
         class="flex flex-col w-full rounded-xl shadow-sm border border-secondary-border bg-component-inner overflow-hidden min-w-[280px] sm:min-w-[400px] mt-4 pt-2 border-t border-primary-border">
      <div class="px-4 py-3 border-b border-secondary-border bg-alt-background flex items-center justify-between">
        <div class="flex items-center gap-2">
          <nz-tag
                  class="!m-0 text-[10px] font-bold uppercase tracking-wider bg-section-background border-secondary-border text-warning shadow-sm flex items-center">
            <i class="fas fa-code-branch mr-1 text-warning"></i>
            <span i18n="@@aiChat.transformationTitle">Transformation</span>
          </nz-tag>
        </div>
      </div>
      <div class="p-4 bg-component-inner flex flex-col gap-3">
        <p
           class="text-[13px] text-primary-text mb-0 font-mono bg-alt-background p-3 rounded border border-secondary-border whitespace-pre-wrap overflow-x-auto">
          {{ message.jsonataTransformation }}</p>
        <div class="flex justify-end mt-1">
          <button nz-button
                  nzType="default"
                  (click)="executeJsonata()"
                  class="border-secondary-border text-secondary-text hover:border-primary hover:text-primary focus:outline-none flex items-center gap-2 rounded shadow-sm px-4 py-1 text-xs transition-colors">
            <i class="fas fa-play"></i>
            <span i18n="@@aiChat.executeTransformationButton">Execute Transformation</span>
          </button>
        </div>
      </div>
    </div>
    }

    @if (message.template || message.displayTemplate) {
    <div class="w-full mt-4 animate-fade-in pt-2 border-t border-primary-border">
      <rapider-template-renderer [template]="message.template || message.displayTemplate"
                                 [data]="message.transformationResult || message.entityData?.data || {}"></rapider-template-renderer>
    </div>
    }

    @if (message.displayComponent) {
    <div
         class="w-full mt-4 animate-fade-in border border-secondary-border rounded-xl bg-component-inner p-4 shadow-sm pt-2 border-t border-primary-border">
      <div class="flex items-center gap-2 mb-3">
        <i class="fas fa-puzzle-piece text-primary"></i>
        <span class="text-xs font-bold uppercase tracking-wider text-secondary-text">Component: {{
          message.displayComponent.componentName || 'Unknown' }}</span>
      </div>
      @if (message.displayComponent.componentName) {
      <div class="text-[11px] text-warning italic mb-2">Dynamic component rendering requested. Placeholder layout.</div>
      }
      <pre
           class="text-[12px] text-primary-text m-0 overflow-x-auto custom-scrollbar p-3 bg-alt-background border border-secondary-border rounded">{{ message.displayComponent.data | json }}</pre>
    </div>
    }

  </div>
  } }

  @if (message.type !== 'action-response') {
  <div class="flex items-center mt-0 w-full"
       [ngClass]="message.isUser ? 'justify-end pr-4' : 'justify-start pl-4 gap-1.5'">
    @if (!message.isUser && message.type === 'ai-message' && message.text) {
    <button nz-tooltip
            [nzTooltipTitle]="isCopied() ? config.texts.copiedAction : config.texts.copyAction"
            (click)="copyMessageText()"
            class="w-5 h-5 flex items-center justify-center rounded text-secondary-text hover:bg-hover-default hover:text-primary transition-colors focus:outline-none -ml-1">
      <i class="fas" [ngClass]="isCopied() ? 'fa-check text-success' : 'fa-regular fa-copy'"></i>
    </button>
    <button nz-tooltip
            i18n-nzTooltipTitle="@@aiChat.saveToSpace" 
            nzTooltipTitle="Save to Space"
            (click)="saveToSpace()"
            class="w-5 h-5 flex items-center justify-center rounded text-secondary-text hover:bg-hover-default hover:text-primary transition-colors focus:outline-none">
      <i class="fas fa-save"></i>
    </button>
    }
    @if (!message.isUser && message.id) {
    <button nz-tooltip
            nzTooltipTitle="Inspect AI Response"
            (click)="isDebugDrawerOpen.set(true)"
            class="w-5 h-5 flex items-center justify-center rounded text-secondary-text hover:bg-hover-default hover:text-primary transition-colors focus:outline-none">
      <i class="fa-regular fa-magnifying-glass-chart text-[12px]"></i>
    </button>
    }
    <span class="text-[10px] text-secondary-text">{{ getFormattedTime() }}</span>
  </div>
  }

  <nz-modal [(nzVisible)]="isPreviewModalVisible"
            [nzTitle]="previewFile()?.name || 'Preview'"
            [nzFooter]="previewFooter"
            (nzOnCancel)="closeAttachmentPreview()"
            nzWidth="80vw"
            nzClassName="attachment-preview-modal">
    <ng-container *nzModalContent>
      <div class="flex items-center justify-center w-full min-h-[50vh] bg-alt-background rounded-lg overflow-hidden">
        @if (previewFile()?.url) {
        <img [src]="previewFile()?.url"
             alt="Attachment Preview"
             class="max-w-full max-h-[70vh] object-contain" />
        } @else {
        <i class="fas fa-image text-4xl text-secondary-text"></i>
        }
      </div>
    </ng-container>
    <ng-template #previewFooter>
      <div class="flex justify-end gap-3">
        <button nz-button
                nzType="default"
                (click)="closeAttachmentPreview()">{{ config.texts.closePreviewBtn }}</button>
        <button nz-button
                nzType="primary"
                (click)="previewFile() ? downloadAttachment(previewFile()!) : null"
                class="bg-primary text-white border-none flex items-center gap-2 shadow-sm">
          <i class="fas fa-download"></i> {{ config.texts.downloadBtn }}
        </button>
      </div>
    </ng-template>
  </nz-modal>

  <rapider-agent-debug-drawer
    [isOpen]="isDebugDrawerOpen()"
    [message]="message"
    (isOpenChange)="isDebugDrawerOpen.set($event)"
  ></rapider-agent-debug-drawer>

</div>
}